import { PaginationResponseType } from 'app/console-api';
import { AUTH_TOKEN } from 'app/constants';
import { HttpError } from 'app/components/utils/http-error';
import { PaginationParams } from 'app/console-api/utils/pagination';

export interface LogData {
  id: string;
  timestamp: Date;
  dealID: string;
  action: string;
  description: string;
  sourceDealID: string;
  userID: string;
}

export interface DealsLogsListItemResponse {
  logData: LogData;
  tsName: string;
}

export const getDealsLogs = async (
  appID: string,
  dealID: string,
  params: PaginationParams
): Promise<PaginationResponseType<DealsLogsListItemResponse>> => {
  const searchParams = new URLSearchParams();
  searchParams.append('pageSize', params.pageSize.toString());
  searchParams.append('currentPage', params.currentPage.toString());

  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/deals/${dealID}/logs?${searchParams.toString()}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      }
    }
  );
  if (!response.ok) {
    return Promise.reject(
      new HttpError(`Failed to get deals logs: ${response.statusText}`, response.status)
    );
  }
  return await response.json();
};
